import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Biztonsági okokból: csak akkor állítjuk vissza a session-t,
    // ha ebben a böngésző-session-ben már volt login (sessionStorage flag).
    // Böngésző bezárás → sessionStorage törlődik → login szükséges.
    const sessionActive = sessionStorage.getItem('session_active');
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    
    if (sessionActive && token && userData) {
      try {
        setUser(JSON.parse(userData));
      } catch (e) {
        console.error('Hiba a user adat betöltésekor:', e);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    } else if (!sessionActive) {
      // Új böngésző session → korábbi token törlése
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
  }, []);

  const login = (userData) => {
    setUser(userData);
    if (userData.token) {
      localStorage.setItem('token', userData.token);
      localStorage.setItem('user', JSON.stringify(userData));
      sessionStorage.setItem('session_active', '1');
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    sessionStorage.removeItem('session_active');
  };

  const hasRole = (role) => {
    if (!user) return false;
    // Support both 'role' (string) and 'roles' (array) formats
    if (user.roles && Array.isArray(user.roles)) {
      return user.roles.includes(role);
    }
    if (user.role) {
      return user.role === role;
    }
    return false;
  };

  const isAdmin = () => {
    return hasRole('Admin');
  };

  const hasPermission = (permissionName) => {
    if (!user) return false;
    // Admin mindenhez hozzáfér
    if (isAdmin()) return true;
    // Ellenőrizzük a konkrét jogosultságot
    if (user.permissions && user.permissions[permissionName]) {
      return true;
    }
    return false;
  };

  const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    if (token) {
      return {
        'Authorization': `Bearer ${token}`
      };
    }
    return {};
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, hasRole, isAdmin, hasPermission, getAuthHeaders }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
